
const CATEGORY_TRANSLATION_KEYS: Record<string, string> = {
  imaging: "productCategories.imagingEquipment",
  surgical: "productCategories.surgicalEquipment",
  laboratory: "productCategories.laboratoryEquipment",
  monitoring: "productCategories.monitoringEquipment",
  respiratory: "productCategories.respiratoryEquipment",
  emergency: "productCategories.emergencyEquipment",
  diagnostic: "productCategories.diagnosticEquipment",
  infusion: "productCategories.infusionEquipment",
};

/**
 * Maps short category keys to full database category names.
 */
const CATEGORY_KEY_TO_DB_NAME: Record<string, string> = {
  imaging: "Imaging Equipment",
  surgical: "Surgical Equipment",
  laboratory: "Laboratory Equipment",
  monitoring: "Monitoring Equipment",
  respiratory: "Respiratory Equipment",
  emergency: "Emergency Equipment",
  diagnostic: "Diagnostic Equipment",
  infusion: "Infusion Equipment",
};

/**
 * Decode the category from the URL param.
 * Maps short categoryKeys (e.g. "imaging") to full database category names
 * (e.g. "Imaging Equipment").
 */
export const getCategoryFromParam = (
  categoryId?: string
): string | undefined => {
  if (!categoryId) return undefined;
  const decoded = decodeURIComponent(categoryId);
  return CATEGORY_KEY_TO_DB_NAME[decoded] || decoded;
};

/**
 * Get a localized breadcrumb label for a category.
 * Falls back to a humanized version of the raw category id.
 */
export const getCategoryBreadcrumbLabel = (
  t: (key: string) => string,
  categoryId?: string
): string => {
  if (!categoryId) {
    return t("products.categoryDetails.breadcrumbDiagnostic");
  }

  const key = CATEGORY_TRANSLATION_KEYS[categoryId];
  if (key) {
    return t(key);
  }

  // Fallback: humanize the category id
  return categoryId.replace(/-/g, " ");
};